__webpack_require__.p = "/register-of-materials/";